import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[softAccordionItemHeader]',
  standalone: true,
})
export class AccordionItemHeaderDirective {
  constructor(public templateRef: TemplateRef<unknown>) { }
}
